import React, { useState, useEffect } from 'react';
import Cloudinary from 'utils/Cloudinary';

interface ImageComponentProps {
  src: string;
  animate?: boolean;
  alt?: any;
  style?: Record<string, unknown>;
  onLoad?: () => void;
  className?: string;
  width?: number;
  height?: number;
  options?: Record<string, unknown>;
  cloudinaryTransform?: boolean;
  [key: string]: any;
}

function transformImage(url, options, cloudinaryTransform) {
  if (!cloudinaryTransform) {
    return url;
  }

  try {
    if (url && url.indexOf('cloudinary') > -1) {
      return Cloudinary.createCloudinaryUrl(url, options);
    }
    return url;
  } catch (e) {
    console.error(e);
    return url;
  }
}

function ImageComponent({ src, alt = '', options, animate, style = {}, cloudinaryTransform = true, onLoad = () => {}, ...others }: ImageComponentProps) {
  const [ready, setReady] = useState(false);

  const animateStyle: any = {};

  if (animate) {
    animateStyle.opacity = ready ? 1 : 0;
    animateStyle.transition = 'opacity .3s';
  }

  const imgStyle = Object.assign({}, style, animateStyle);
  const imgSrc = transformImage(src, options, cloudinaryTransform);

  useEffect(() => {
    const image = new Image();

    const onImageLoad = () => {
      setReady(true);
      onLoad();
    };

    image.addEventListener('load', onImageLoad);

    image.src = imgSrc;

    return () => {
      image.removeEventListener('load', onImageLoad);
    };
  }, [imgSrc, onLoad]);

  return (
    <img
      alt={alt}
      style={imgStyle}
      src={imgSrc}
      {...others}
    />
  );
}

export default ImageComponent;
